module.exports = {
  exploreMode: [],
  filterMode: []
}
